import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'
import useCreditNote from '@hooks/useCreditNote'

import type { CampaignModel } from '@models/types'

import AddCreditNote from '../../assets/add_credit_note.svg'

const AddCreditNoteButton = (props: { campaign: CampaignModel }) => {
  const { campaign } = props

  const creditNote = {
    campaign_id: campaign.id,
    creditor_id: campaign.agency_id,
    creditor_type: 'Agency',
  }

  const { callbacks: { createOrEditCreditNote } } = useCreditNote(creditNote)

  return (
    <ListItem
      borderColor="lineColor"
      boxProps={{
        alignItems: 'center',
        border: '1px solid',
        borderRadius: 5,
        marginTop: 'medium',
        padding: 'large',
      }}
      onClick={() => createOrEditCreditNote()}
      forceBottomBorder
      showAngleIcon
    >
      <Image backgroundSize="contain" url={AddCreditNote} width={40} height={40} />

      <Box flexDirection="column" marginLeft="large">
        <Text>Add Credit Note</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">Add a Credit Note or Adjustment</Text>
      </Box>
    </ListItem>
  )
}
export default AddCreditNoteButton
